import React from "react";
import { cn } from "../lib/utils";
import Marquee from "./magicui/Marquee";

const achievements = [

  { idText: "1", achievement: "Finalist at AI-Volution Hackathon 2025 among 8500+ participants by building an AI-powered document system." },
  { idText: "2", achievement: "Top Project Admin at GSSOC 2024, guided 100+ PRs and mentored contributors in open-source community." },
  { idText: "3", achievement: "Built optimization platform at Walmart Sparkathon Hackathon 2025 to reduce cost and emissions using routing APIs." },
  { idText: "4", achievement: "Recognised as Top 1% Contributor among 3,400+ in Social Summer of Code 2024 for impactful open-source work." },
  { idText: "5", achievement: "Part of Opensoft General Championship 2024 winning team; integrated HLS Adaptive Bitrate Streaming for m3u8." },
  { idText: "6", achievement: "Represented IIT Kharagpur Institute Badminton Team (2023–Present), securing 4th place in GC 2024 and 2025." },
  { idText: "7", achievement: "Served as Centre Superintendent for NDST-2023 and mentored JEE aspirants during JOSSA counselling sessions." },
  { idText: "8", achievement: "Recipient of Dakshana Scholarship (2020), awarded to top 1% JNV students for 2-year JEE coaching program." },
  // { idText: "9", achievement: "Achieved Codeforces peak rating of 942 under handle 'Vitality1', showcasing problem-solving and algorithms skill on 2024" },
  { idText: "9", achievement: "Honored for open-source contributions by leading Fitflex project at GirlScript Summer of Code 2024." },
];

const firstRow = achievements.slice(0, Math.ceil(achievements.length / 2));
const secondRow = achievements.slice(Math.ceil(achievements.length / 2));

const AchievementCard = ({
  idText,
  achievement,
}: {
  idText: string;
  achievement: string;
}) => {
  return (
    <figure
      className={cn(
        // Mobile-first widths: w-64 for small screens, sm:w-80 for larger ones
        "relative w-64 sm:w-80 cursor-pointer overflow-hidden rounded-xl p-4 sm:p-6 mx-2",
        "backdrop-blur-sm border-2 shadow-lg",
        "hover:shadow-xl hover:scale-[1.02]",
        "transition-all duration-300 ease-out",
        "will-change-transform"
      )}
      style={{
        backgroundColor: "#0A0A0A",
        borderColor: "#64FFDA",
        boxShadow: "0 4px 12px rgba(100, 255, 218, 0.08)",
      }}
    >
      <div className="flex flex-col space-y-2 sm:space-y-3">
        <blockquote
          className="text-xs sm:text-sm leading-relaxed font-medium line-clamp-3 sm:line-clamp-4"
          style={{ color: "#8892B0" }}
        >
          {achievement}
        </blockquote>
        
        <div className="flex items-center space-x-2 pt-1 border-t border-white/5">
           <div className="flex space-x-1">
            {[...Array(3)].map((_, i) => (
              <div
                key={i}
                className="w-1 h-1 rounded-full"
                style={{ backgroundColor: "#64FFDA" }}
              />
            ))}
          </div>
          <span
            className="text-[10px] sm:text-xs font-medium opacity-70"
            style={{ color: "#8892B0" }}
          >
            Milestone #{idText}
          </span>
        </div>
      </div>
    </figure>
  );
};

export function MarqueeDemo() {
  return (
    <div
      className="relative flex h-[400px] sm:h-[500px] w-full flex-col items-center justify-center overflow-hidden rounded-2xl"
      style={{ backgroundColor: "#0A0A0A" }}
    >
      {/* Mobile-Responsive Header */}
      <div className="absolute top-4 sm:top-6 left-1/2 transform -translate-x-1/2 z-10 w-max">
        <div
          className="backdrop-blur-sm px-4 py-1.5 sm:px-6 sm:py-2 rounded-full border border-primaryColor/50 sm:border-2"
          style={{
            backgroundColor: "#0A0A0A",
            borderColor: "#64FFDA",
            boxShadow: "0 4px 15px rgba(100, 255, 218, 0.15)",
          }}
        >
          <h3 className="text-sm sm:text-lg font-semibold" style={{ color: "#64FFDA" }}>
            Achievements
          </h3>
        </div>
      </div>

      <div className="flex flex-col gap-1 sm:gap-4 mt-8">
        {/* First Row */}
        <Marquee
          pauseOnHover
          className="[--duration:30s] py-2"
        >
          {firstRow.map((achievement) => (
            <AchievementCard key={achievement.idText} {...achievement} />
          ))}
        </Marquee>

        {/* Second Row */}
        <Marquee
          reverse
          pauseOnHover
          className="[--duration:35s] py-2"
        >
          {secondRow.map((achievement) => (
            <AchievementCard key={achievement.idText} {...achievement} />
          ))}
        </Marquee>
      </div>

      {/* Edge Gradients - Reduced width on mobile to show more content */}
      <div
        className="pointer-events-none absolute inset-y-0 left-0 w-1/6 sm:w-1/4 z-10"
        style={{
          background: `linear-gradient(to right, #0A0A0A, transparent)`,
        }}
      />
      <div
        className="pointer-events-none absolute inset-y-0 right-0 w-1/6 sm:w-1/4 z-10"
        style={{
          background: `linear-gradient(to left, #0A0A0A, transparent)`,
        }}
      />
    </div>
  );
}